export interface VideoItem {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  rating: number;
  year: number;
  description: string;
  duration: string;
  tags: string[];
  featured: boolean;
  trending: boolean;
  latest: boolean;
  views: string;
  updateDate: string;
}

export const categories: { name: string; slug: string; icon: string; description: string }[] = [
  { name: '电视剧', slug: 'tv-series', icon: 'ri-tv-line', description: '海量电视剧全集，热门新剧抢先看，经典老剧随时回味' },
  { name: '电影', slug: 'movies', icon: 'ri-film-line', description: '院线大片、经典电影、高分佳作，尽在棒棒TV电影大全' },
  { name: '综艺', slug: 'variety', icon: 'ri-emotion-happy-line', description: '热门综艺节目，搞笑娱乐不停歇，周末快乐源泉' },
  { name: '动漫', slug: 'anime', icon: 'ri-ghost-line', description: '热血动漫、治愈番剧，二次元世界精彩纷呈' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-earth-line', description: 'BBC纪录片、自然探索、人文历史，开阔你的视野' },
  { name: '少儿', slug: 'kids', icon: 'ri-user-smile-line', description: '优质少儿节目，寓教于乐，陪伴孩子快乐成长' },
];

export const videos: VideoItem[] = [
  {
    id: 'v1', title: '繁花', category: '电视剧', categorySlug: 'tv-series',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20set%20in%201990s%20Shanghai%2C%20warm%20golden%20lighting%2C%20elegant%20characters%20in%20vintage%20clothing%2C%20nostalgic%20atmosphere%2C%20cinematic%20photography%2C%20rich%20color%20tones%2C%20soft%20bokeh%20background&width=800&height=450&seq=v1-fanhua&orientation=landscape',
    rating: 9.3, year: 2024, description: '九十年代的上海处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼，跻身成为商界后起之秀。黄河路上，人人都在争一口气。',
    duration: '45分钟/集', tags: ['剧情', '年代', '商战'], featured: true, trending: true, latest: false,
    views: '12.8亿', updateDate: '2024-03-15',
  },
  {
    id: 'v2', title: '流浪地球2', category: '电影', categorySlug: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=sci-fi%20movie%20scene%20with%20massive%20space%20elevator%20and%20futuristic%20earth%2C%20epic%20cinematic%20lighting%2C%20dramatic%20clouds%2C%20vast%20scale%2C%20cool%20blue%20and%20orange%20tones&width=800&height=450&seq=v2-wandering-earth&orientation=landscape',
    rating: 9.2, year: 2023, description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，年轻人再次挺身而出，展开争分夺秒的生死之战。',
    duration: '173分钟', tags: ['科幻', '灾难', '冒险'], featured: true, trending: true, latest: false,
    views: '8.5亿', updateDate: '2023-12-20',
  },
  {
    id: 'v3', title: '庆余年第二季', category: '电视剧', categorySlug: 'tv-series',
    thumbnail: 'https://readdy.ai/api/search-image?query=ancient%20Chinese%20costume%20drama%20scene%2C%20palace%20interior%20with%20intricate%20decorations%2C%20characters%20in%20elaborate%20traditional%20robes%2C%20warm%20lantern%20lighting%2C%20dramatic%20shadows%2C%20cinematic%20composition&width=800&height=450&seq=v3-qingyunian&orientation=landscape',
    rating: 9.0, year: 2024, description: '范闲率领使团回归途中，二皇子以费介、范思辙以及滕家遗孤的安危来威胁范闲，逼他向自己俯首称臣，二人的矛盾就此激发。',
    duration: '45分钟/集', tags: ['古装', '权谋', '喜剧'], featured: true, trending: true, latest: true,
    views: '18.2亿', updateDate: '2024-06-01',
  },
  {
    id: 'v4', title: '孤注一掷', category: '电影', categorySlug: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=suspenseful%20thriller%20movie%20scene%20with%20dim%20lighting%2C%20intense%20atmosphere%2C%20computer%20screens%20glowing%20in%20dark%20room%2C%20crime%20drama%20aesthetic%2C%20high%20contrast%20cinematography&width=800&height=450&seq=v4-no-more-bets&orientation=landscape',
    rating: 8.9, year: 2023, description: '程序员潘生与模特梁安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手，从他们身上套现。',
    duration: '130分钟', tags: ['犯罪', '悬疑', '剧情'], featured: false, trending: true, latest: false,
    views: '15.3亿', updateDate: '2023-09-10',
  },
  {
    id: 'v5', title: '乘风破浪的姐姐', category: '综艺', categorySlug: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20performance%20with%20colorful%20lighting%2C%20female%20performers%20in%20glamorous%20outfits%2C%20grand%20stage%20design%2C%20dynamic%20spotlights%2C%20entertainment%20show%20atmosphere&width=800&height=450&seq=v5-sisters&orientation=landscape',
    rating: 8.7, year: 2024, description: '30+位姐姐齐聚舞台，用汗水和努力重新定义女性的魅力。她们在舞台上绽放光芒，用实力证明年龄从不是限制。',
    duration: '90分钟/期', tags: ['真人秀', '音乐', '女性'], featured: true, trending: false, latest: true,
    views: '22.5亿', updateDate: '2024-05-20',
  },
  {
    id: 'v6', title: '长安三万里', category: '动漫', categorySlug: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=animated%20Chinese%20historical%20movie%20scene%20set%20in%20Tang%20Dynasty%2C%20ancient%20Chinese%20city%20with%20traditional%20architecture%2C%20poetic%20atmosphere%2C%20warm%20sunset%20lighting%2C%20ink%20painting%20style&width=800&height=450&seq=v6-changan&orientation=landscape',
    rating: 9.1, year: 2023, description: '安史之乱后数年，吐蕃大军入侵西南，大唐节度使高适交战不利。困守孤城的高适向监军太监回忆起自己与李白的一生往事。',
    duration: '168分钟', tags: ['动画', '历史', '诗歌'], featured: false, trending: false, latest: false,
    views: '6.7亿', updateDate: '2023-07-08',
  },
  {
    id: 'v7', title: '三体', category: '电视剧', categorySlug: 'tv-series',
    thumbnail: 'https://readdy.ai/api/search-image?query=sci-fi%20television%20series%20scene%20with%20mysterious%20cosmic%20elements%2C%20scientific%20laboratory%20setting%2C%20dark%20and%20atmospheric%20lighting%2C%20futuristic%20technology%2C%20suspenseful%20mood&width=800&height=450&seq=v7-three-body&orientation=landscape',
    rating: 8.8, year: 2023, description: '纳米科学家汪淼被警官史强带入联合作战中心，潜入名为"科学边界"的组织，揭开地外文明"三体"世界的神秘面纱。',
    duration: '50分钟/集', tags: ['科幻', '悬疑', '剧情'], featured: false, trending: true, latest: false,
    views: '9.1亿', updateDate: '2023-04-20',
  },
  {
    id: 'v8', title: '满江红', category: '电影', categorySlug: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=historical%20Chinese%20movie%20scene%20in%20Song%20Dynasty%20setting%2C%20ancient%20courtyard%20architecture%2C%20soldiers%20in%20traditional%20armor%2C%20dramatic%20lighting%2C%20tense%20atmosphere%2C%20cinematic%20wide%20shot&width=800&height=450&seq=v8-manjianghong&orientation=landscape',
    rating: 8.5, year: 2023, description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。小兵张大与亲兵营副统领孙均被裹挟进巨大的阴谋之中。',
    duration: '159分钟', tags: ['历史', '悬疑', '喜剧'], featured: false, trending: false, latest: false,
    views: '16.8亿', updateDate: '2023-01-22',
  },
  {
    id: 'v9', title: '地球脉动第三季', category: '纪录片', categorySlug: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=stunning%20nature%20documentary%20scene%20with%20diverse%20wildlife%20in%20natural%20habitat%2C%20breathtaking%20landscape%20photography%2C%20vivid%20colors%2C%20animals%20in%20action%2C%20cinematic%20aerial%20shot&width=800&height=450&seq=v9-planet-earth&orientation=landscape',
    rating: 9.7, year: 2024, description: '从海洋深处到最偏远的丛林，全新的地球脉动将带您见证自然界中最壮观、最令人惊叹的奇迹。',
    duration: '60分钟/集', tags: ['自然', '动物', '地理'], featured: true, trending: false, latest: true,
    views: '4.3亿', updateDate: '2024-02-28',
  },
  {
    id: 'v10', title: '熊出没·逆转时空', category: '少儿', categorySlug: 'kids',
    thumbnail: 'https://readdy.ai/api/search-image?query=colorful%20animated%20movie%20scene%20with%20cartoon%20bears%20in%20forest%20setting%2C%20bright%20and%20cheerful%20colors%2C%20children%20animation%20style%2C%20playful%20atmosphere%2C%20family%20friendly%20imagery&width=800&height=450&seq=v10-boonie-bears&orientation=landscape',
    rating: 8.3, year: 2024, description: '光头强是一名普通程序员，却常梦见陌生的森林和两头狗熊。直到一次意外，他穿越回狗熊岭，开启了一段奇妙的时空冒险。',
    duration: '99分钟', tags: ['动画', '喜剧', '冒险'], featured: false, trending: false, latest: true,
    views: '7.8亿', updateDate: '2024-02-10',
  },
  {
    id: 'v11', title: '狂飙', category: '电视剧', categorySlug: 'tv-series',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20scene%2C%20police%20investigation%20setting%2C%20tense%20urban%20atmosphere%2C%20dark%20and%20gritty%20visual%20style%2C%20two%20men%20facing%20each%20other%2C%20dramatic%20lighting&width=800&height=450&seq=v11-the-knockout&orientation=landscape',
    rating: 9.4, year: 2023, description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海。',
    duration: '45分钟/集', tags: ['犯罪', '剧情', '扫黑'], featured: true, trending: true, latest: false,
    views: '28.6亿', updateDate: '2023-03-10',
  },
  {
    id: 'v12', title: '你好，星期六', category: '综艺', categorySlug: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20studio%20set%20with%20bright%20colorful%20stage%20design%2C%20hosts%20and%20guests%20playing%20games%2C%20cheerful%20atmosphere%2C%20studio%20lighting%2C%20entertainment%20television%20production&width=800&height=450&seq=v12-hello-saturday&orientation=landscape',
    rating: 8.1, year: 2024, description: '一档全新的季度综艺节目，通过新奇多样的环节设置，让嘉宾和观众一起感受周末的快乐时光。',
    duration: '90分钟/期', tags: ['真人秀', '游戏', '搞笑'], featured: false, trending: false, latest: true,
    views: '11.2亿', updateDate: '2024-07-15',
  },
  {
    id: 'v13', title: '哪吒之魔童降世', category: '动漫', categorySlug: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20with%20mythological%20character%20with%20fire%20and%20magical%20powers%2C%20dynamic%20action%20scene%2C%20vibrant%20colors%2C%85Chinese%20ink%20painting%20aesthetic%2C%20epic%20composition&width=800&height=450&seq=v13-nezha&orientation=landscape',
    rating: 9.3, year: 2019, description: '天地灵气孕育出一颗混元珠，元始天尊将混元珠提炼成灵珠和魔丸，灵珠投胎为人，助周伐纣时可堪大用；而魔丸则会诞出魔王，为祸人间。',
    duration: '110分钟', tags: ['动画', '神话', '动作'], featured: false, trending: false, latest: false,
    views: '20.5亿', updateDate: '2019-07-26',
  },
  {
    id: 'v14', title: '舌尖上的中国第四季', category: '纪录片', categorySlug: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20traditional%20cooking%20in%20rustic%20kitchen%2C%20steaming%20dishes%2C%20fresh%20ingredients%2C%20warm%20natural%20lighting%2C%20authentic%20Chinese%20cuisine%20photography&width=800&height=450&seq=v14-bite-of-china&orientation=landscape',
    rating: 9.2, year: 2024, description: '从食材获取、烹饪技艺到饮食文化，全面展现中国人对美食和生活的美好追求，用镜头记录中国特色美食的生态。',
    duration: '50分钟/集', tags: ['美食', '文化', '人文'], featured: false, trending: true, latest: true,
    views: '5.6亿', updateDate: '2024-04-18',
  },
  {
    id: 'v15', title: '超级飞侠', category: '少儿', categorySlug: 'kids',
    thumbnail: 'https://readdy.ai/api/search-image?query=bright%20colorful%203D%20animated%20children%20series%20with%20cute%20airplane%20characters%2C%20world%20travel%20theme%2C%20cheerful%20and%20educational%20atmosphere%2C%20simple%20and%20clean%20visual%20style&width=800&height=450&seq=v15-super-wings&orientation=landscape',
    rating: 8.6, year: 2024, description: '超级飞侠们飞往世界各地，为小朋友们递送包裹，帮助他们解决困难，在这个过程中学习各国的地理知识和风土人情。',
    duration: '13分钟/集', tags: ['动画', '教育', '冒险'], featured: false, trending: false, latest: true,
    views: '15.9亿', updateDate: '2024-06-20',
  },
  {
    id: 'v16', title: '封神第一部', category: '电影', categorySlug: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=epic%20Chinese%20fantasy%20movie%20scene%20with%20ancient%20mythological%20warriors%2C%20grand%20battle%20scenes%2C%20dramatic%20skies%2C%20elaborate%20costumes%2C%20cinematic%20epic%20scale%2C%20warm%20golden%20and%20red%20tones&width=800&height=450&seq=v16-fengshen&orientation=landscape',
    rating: 8.7, year: 2023, description: '殷商末年，狐妖妲己惑乱朝纲，商王殷寿暴虐无道。昆仑仙人姜子牙携"封神榜"下山，寻找天下共主，以救苍生。',
    duration: '148分钟', tags: ['奇幻', '神话', '动作'], featured: false, trending: true, latest: false,
    views: '9.8亿', updateDate: '2023-07-20',
  },
];

export const featuredVideos: VideoItem[] = [
  {
    id: 'fv1', title: '玫瑰的故事', category: '电视剧', categorySlug: 'tv-series',
    thumbnail: 'https://readdy.ai/api/search-image?query=elegant%20Chinese%20romantic%20drama%20scene%20with%20beautiful%20female%20lead%20in%20modern%20city%20setting%2C%20soft%20warm%20lighting%2C%20fashionable%20wardrobe%2C%20emotional%20atmosphere%2C%20cinematic%20quality%2C%20rose%20flower%20motif&width=1280&height=600&seq=fv1-rose-story&orientation=landscape',
    rating: 9.0, year: 2024, description: '黄亦玫跨越二十余年的成长与蜕变，从青涩少女到成熟女性，一路上的情感经历与事业起伏，书写属于她自己的玫瑰人生。',
    duration: '45分钟/集', tags: ['都市', '爱情', '成长'], featured: true, trending: true, latest: true,
    views: '14.2亿', updateDate: '2024-07-01',
  },
  {
    id: 'fv2', title: '热辣滚烫', category: '电影', categorySlug: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20comedy-drama%20movie%20scene%20with%20boxing%20ring%2C%20inspirational%20atmosphere%2C%20warm%20lighting%2C%20female%20protagonist%20in%20sportswear%2C%20motivational%20theme%2C%20cinematic%20composition&width=1280&height=600&seq=fv2-yolo&orientation=landscape',
    rating: 8.6, year: 2024, description: '宅家多年的杜乐莹结识了拳击教练昊坤。当她以为生活即将步入正轨时，考验接踵而至，滚烫的人生才刚刚开始。',
    duration: '129分钟', tags: ['喜剧', '运动', '励志'], featured: true, trending: true, latest: true,
    views: '19.8亿', updateDate: '2024-02-10',
  },
  {
    id: 'fv3', title: '墨雨云间', category: '电视剧', categorySlug: 'tv-series',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20drama%20with%20rain%20scene%2C%20two%20characters%20in%20traditional%20costumes%20under%20umbrella%2C%20moody%20atmospheric%20lighting%2C%20ancient%20Chinese%20street%20setting%2C%20emotional%20and%20poetic%20visual&width=1280&height=600&seq=fv3-moyu-yunjian&orientation=landscape',
    rating: 8.8, year: 2024, description: '县令之女薛芳菲被夫君所害后，在姜梨相助下以姜梨身份回到京城，与肃国公萧蘅并肩作战，揭开重重阴谋。',
    duration: '45分钟/集', tags: ['古装', '爱情', '权谋'], featured: true, trending: true, latest: true,
    views: '16.5亿', updateDate: '2024-06-15',
  },
];

export const articleContent: Record<string, {
  title: string;
  author: string;
  publishDate: string;
  category: string;
  tags: string[];
  summary: string;
  content: string;
  relatedVideos: string[];
}> = {
  'v1': {
    title: '繁花 — 九十年代上海滩的浮世绘',
    author: '棒棒TV编辑部',
    publishDate: '2024-03-20',
    category: '电视剧',
    tags: ['繁花', '王家卫', '上海', '年代剧', '胡歌'],
    summary: '《繁花》以九十年代的上海为背景，通过阿宝的视角展现了那个充满机遇与挑战的时代。王家卫导演以独特的影像风格，呈现了一幅绚丽多彩的上海滩浮世绘。',
    content: `<p>《繁花》自播出以来，凭借其精良的制作、深刻的剧情和出色的演员阵容，迅速成为年度现象级电视剧。该剧改编自金宇澄的同名小说，由著名导演王家卫执导，胡歌、马伊琍、唐嫣、辛芷蕾等一众实力派演员倾情出演。</p>
<p>故事发生在九十年代的上海，改革开放的春风吹遍神州大地，处处充满了机遇与希望。青年阿宝（胡歌饰）凭借自己的聪明才智和坚韧不拔的精神，从一名普通的工厂工人一步步成长为商界大亨。在这个过程中，他结识了多位对他人生影响深远的人物。</p>
<p>黄河路是故事的核心舞台，这条繁华的商业街上，每个人都在为生活打拼，为梦想奋斗。剧中的美食、服饰、音乐和街道景观都高度还原了90年代上海的城市风貌，让观众仿佛穿越回那个充满激情的年代。</p>
<p>王家卫导演用他一贯的独特美学风格，将上海的繁华与落寞、喧嚣与孤寂、光鲜与挣扎表现得淋漓尽致。每一帧画面都如同精心构图的摄影作品，配合深情的旁白和恰到好处的配乐，营造出浓厚的怀旧氛围。</p>
<p>《繁花》不仅是一部商战剧，更是一部关于人情冷暖、时代变迁的史诗。它告诉我们：在这个瞬息万变的世界里，唯有真情与初心，才是指引我们前行的明灯。</p>`,
    relatedVideos: ['v3', 'v7', 'v11'],
  },
  'v2': {
    title: '流浪地球2 — 中国科幻的新里程碑',
    author: '棒棒TV编辑部',
    publishDate: '2023-12-28',
    category: '电影',
    tags: ['流浪地球2', '科幻', '吴京', '刘德华', '郭帆'],
    summary: '《流浪地球2》以宏大的叙事格局和震撼的视觉效果，讲述了一个关于人类命运共同体的科幻故事。影片在技术层面实现了中国电影工业的重大突破。',
    content: `<p>《流浪地球2》作为前传，讲述了"太阳危机"即将来袭，世界陷入一片恐慌之中。面对这场关乎人类生存的重大危机，各国放下纷争，联合起来实施"移山计划"，在月球上安装行星发动机，试图推动地球离开太阳系。</p>
<p>影片通过三条主线展开：刘培强（吴京饰）的成长之路、图恒宇（刘德华饰）与女儿丫丫的感人故事、以及周喆直（李雪健饰）在国际舞台上的外交斡旋。三条线索交织在一起，共同构成了这部宏大叙事的科幻电影。</p>
<p>在视觉效果方面，《流浪地球2》实现了中国电影工业的重大突破。太空电梯、月球基地、行星发动机等大型场景的呈现，都达到了国际一流水平。特别是太空电梯的长镜头，让观众仿佛置身于地球与太空之间的壮丽旅程。</p>
<p>影片深刻地探讨了"数字生命"这一哲学命题。当人类面临生存危机时，是选择保留肉体还是保留意识？这个深刻的命题引发了观众的广泛讨论和思考。</p>
<p>《流浪地球2》不仅是一部科幻电影，更是一部关于爱、责任与牺牲的感人故事。它告诉我们：无论面对多大的困难，只要人类团结一致，就一定能够创造奇迹。</p>`,
    relatedVideos: ['v8', 'v13', 'v16'],
  },
};

export const aboutData = {
  brandIntro: '棒棒TV成立于2020年，是一家专注于为用户提供免费高清视频在线播放服务的平台。我们致力于打造极致的观影体验，以"在线不缓冲秒播，即点即看零等待"为核心理念，让每一位用户都能畅享流畅的高清视频内容。',
  mission: '我们的使命是让优质视频内容触手可及。无论您身在何处，无论您使用的是何种设备，棒棒TV都将为您提供稳定、流畅、高清的视频播放服务。我们相信，好的内容应该被更多人看到。',
  features: [
    {
      icon: 'ri-flashlight-line',
      title: '秒播技术',
      description: '采用先进的视频加速技术，实现真正的即点即看零等待，告别缓冲烦恼。',
    },
    {
      icon: 'ri-4k-line',
      title: '高清画质',
      description: '全面支持1080P和4K超高清播放，为您呈现每一帧的精彩细节。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端适配',
      description: '完美适配手机、平板、电脑等全终端设备，随时随地畅享精彩内容。',
    },
    {
      icon: 'ri-vip-crown-line',
      title: '完全免费',
      description: '所有内容均可免费观看，无需会员，无需付费，真正实现零门槛观看。',
    },
  ],
  stats: [
    { value: '5000万+', label: '月活跃用户' },
    { value: '10万+', label: '影视资源' },
    { value: '99.9%', label: '播放成功率' },
    { value: '30+', label: '内容分类' },
  ],
  contact: {
    email: 'contact@bangbangtv.com',
    wechat: '棒棒TV官方',
    weibo: '@棒棒TV',
    address: '中国北京市朝阳区建国路88号',
    phone: '400-888-9999',
  },
  faqs: [
    {
      question: '棒棒TV真的完全免费吗？',
      answer: '是的，棒棒TV所有视频内容均可免费观看，无需注册会员，无需支付任何费用。我们通过广告收入来维持平台运营，为用户提供持续稳定的免费服务。',
    },
    {
      question: '为什么棒棒TV可以实现秒播不缓冲？',
      answer: '棒棒TV采用业界领先的CDN加速技术和智能分发系统，在全国范围内部署了数千个加速节点。当您点击播放时，系统会自动选择距离您最近的节点进行传输，从而实现零等待秒播体验。',
    },
    {
      question: '支持哪些设备观看？',
      answer: '棒棒TV完美适配PC、手机、平板、智能电视等多种设备。您可以通过浏览器直接访问我们的网站，在任何设备上畅享高清视频内容。',
    },
    {
      question: '视频画质最高支持多少？',
      answer: '棒棒TV全面支持1080P全高清和4K超高清画质播放。系统会根据您的网络状况和设备性能，智能推荐最适合的画质选项，确保流畅的观看体验。',
    },
    {
      question: '如何联系棒棒TV客服？',
      answer: '您可以通过以下方式联系我们：发送邮件至contact@bangbangtv.com，或在工作时间拨打客服热线400-888-9999。我们也欢迎您通过微信公众号"棒棒TV官方"与我们互动。',
    },
  ],
  testimonials: [
    {
      name: '张先生',
      avatar: 'ri-user-3-line',
      rating: 5,
      text: '棒棒TV真的太好用了！之前在其他平台看剧总是卡顿，用了棒棒TV之后再也没有遇到过缓冲的问题，画质还特别清晰。',
    },
    {
      name: '李女士',
      avatar: 'ri-user-3-line',
      rating: 5,
      text: '资源太全了！想看的电视剧和电影基本都能找到，而且完全免费，已经推荐给身边所有朋友了。',
    },
    {
      name: '王同学',
      avatar: 'ri-user-3-line',
      rating: 5,
      text: '作为一个追剧党，棒棒TV简直就是我的救星。新剧更新速度很快，画质和流畅度都没话说，强烈推荐！',
    },
    {
      name: '刘女士',
      avatar: 'ri-user-3-line',
      rating: 4.5,
      text: '界面简洁干净，没有任何垃圾广告弹窗。分类也很清晰，找片子非常方便。家里老人小孩都会用，真的很棒。',
    },
  ],
};